import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';

const BoardLocalStorage = createLocalStorageProvider('jira_business_jwm-board');
const STORAGE_KEY_EXPANDED_TASKS = 'EXPANDED_TASKS';

const buildExpandedTasksKey = (projectId: string) => `${STORAGE_KEY_EXPANDED_TASKS}_${projectId}`;

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
const LocalStorage = {
	getExpandedTasks: (projectId: string): number[] => {
		const data = BoardLocalStorage.get(buildExpandedTasksKey(projectId));
		if (Array.isArray(data)) {
			return data;
		}
		return [];
	},
	setExpandedTasks: (projectId: string, issueIds: number[]) =>
		BoardLocalStorage.set(buildExpandedTasksKey(projectId), issueIds),
} as const;

export default LocalStorage;
